export default __webpack_public_path__ + "static/media/right-side-background.0ce2419d.svg";